import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=6f5a240d&scoped=true&"
import script from "./submit.vue?vue&type=script&lang=js&"
export * from "./submit.vue?vue&type=script&lang=js&"
import style0 from "./submit.vue?vue&type=style&index=0&id=6f5a240d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a240d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f5a240d')) {
      api.createRecord('6f5a240d', component.options)
    } else {
      api.reload('6f5a240d', component.options)
    }
    module.hot.accept("./submit.vue?vue&type=template&id=6f5a240d&scoped=true&", function () {
      api.rerender('6f5a240d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/order/components/submit.vue"
export default component.exports